export function sinFromDegrees(angle: number) {
  return Math.sin(angle * (Math.PI / 180))
}

export function cosFromDegrees(angle: number) {
  return Math.cos(angle * (Math.PI / 180))
}

export function precisionRound(number: number, precision: number) {
  const factor = Math.pow(10, precision)
  return Math.round(number * factor) / factor
}

export function radiansToDegrees(radians: number) {
  return radians * (180 / Math.PI)
}

export function clamp(value: number, min: number, max: number) {
  return Math.max(Math.min(value, max), min)
}
